module.exports = __webpack_public_path__ + "img/2.21199a92.png";